import React, { Component } from 'react';
import { withRouter } from '../ganchos/withRouter';
import ApiService from '../service/ApiService';
import UtilService from '../service/UtilService';
import { Menubar } from 'primereact/menubar';
import IconeHay from "../images/logo-loading.png";
import { Dropdown } from 'primereact/dropdown';
import moment from 'moment/moment';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            atendimentosoftware: null,
            atendimentossoftware: [],
            atendimentosoftwareversao: null,
            atendimentosoftwareversoes: [],
        }
    }

    async componentDidMount() {
        const retorno = await ApiService.consultaSoftware();
        const estado = { atendimentossoftware: retorno.registros };
        const params = UtilService.getAllParams();
        if(params.atendimentosoftware){
            const atendimentosoftware = estado.atendimentossoftware.find(item => item.id === params.atendimentosoftware);
            if (atendimentosoftware) {
                estado.atendimentosoftware = atendimentosoftware;
                await this.onChangeSoftware({ atendimentosoftware }, params.atendimentosoftwareversao == "last");
            }
        }
        this.setState(estado);
    }

    async onChangeSoftware(params, setlast = false){
        if (params.atendimentosoftware){
            const retorno = await ApiService.consultaReleaseNotes(params.atendimentosoftware);
            const estado = { atendimentosoftwareversoes: retorno.registros, atendimentosoftware: params.atendimentosoftware,atendimentosoftwareversao: null };
            if (setlast){
                estado.atendimentosoftwareversao = estado.atendimentosoftwareversoes[0];
            }
            return this.setState(estado);
        } 
        return this.setState({ atendimentosoftware: null,  atendimentosoftwareversao: null,atendimentosoftwareversoes: [] });
    }

    render() {
        const listTemplate = (items) => {
            if (!items || items.length === 0) return null;

            let list = items.map((product, index) => {
                return this.itemTemplate(product, index);
            });

            return <div className="grid grid-nogutter">{list}</div>;
        };

        const start = <div className="quadrante-menu-superior pl-2 ml-2 md:pl-6 md:ml-6 lg:pl-8 lg:ml-8 flex flex-row">
            <img className="flex-shrink-1 mr-2" alt="logo" src={IconeHay} height="40"></img>
            <p className="flex-1 m-1 p-2" style={{ color: '#FFF' }}>HaY Systems - Release Notes</p>
        </div>
        return (
            <>
                <div className="card menu-superior" style={{ backgroundColor: "#343A40" }}>
                    <Menubar start={start}  />
                    <div className="p-2 m-2 md:px-6 md:mx-6 lg:px-8 lg:mx-8 flex flex-column md:flex-row gap-5" >
                        <div class="flex flex-1">
                            <Dropdown 
                            emptyMessage="Nenhum Software Encontrado"
                            value={this.state.atendimentosoftware} 
                            onChange={(e) => this.onChangeSoftware({ atendimentosoftware: e.value})} 
                            options={this.state.atendimentossoftware} 
                            optionLabel="descricao" 
                            showClear 
                            placeholder="Selecione um Software" className="flex-1" />
                        </div>
                        <div class="flex flex-1">
                            <Dropdown 
                            emptyMessage="Nenhuma Versão Encontrada"
                            value={this.state.atendimentosoftwareversao} 
                            onChange={(e) => this.setState({ atendimentosoftwareversao: e.value})} 
                            options={this.state.atendimentosoftwareversoes} 
                            valueTemplate={(item) =>  {
                                if (item && item.id){
                                    return <> Versão: <b>{item?.versao}</b> Data: <b>{moment(item?.atualizadoem).format("DD/MM/YYYY")}</b></>;
                                }
                                return "Selecione uma Versão";
                            }}      
                            itemTemplate={(item) =>  {
                                return <> Versão: <b>{item?.versao}</b> Data: <b>{moment(item?.atualizadoem).format("DD/MM/YYYY")}</b></>;
                            }} 
                            optionLabel="versao" 
                            showClear 
                            placeholder="Selecione uma Versão" className="flex-1" />
                        </div>
                    </div>
                    <div className="px-2 mx-2 md:px-6 md:mx-6 lg:px-8 lg:mx-8 flex flex-column md:flex-row gap-5" >
                        <p style={{color: "#FFF", whiteSpace: 'pre-wrap'}}>{this.state.atendimentosoftwareversao?.descricao}</p>
                    </div>
                </div>
            </>
        )
    }
}
export default withRouter(Dashboard);